import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

import { SkiliticsIcon } from "../icons";

export const mapTypeIdToIcon = (typeId: string) => {
  switch (typeId) {
    case "audio":
      return <SkiliticsIcon key="audio-icon" icon="layer-audio" size={16} />;

    case "image":
      return <SkiliticsIcon key="image-icon" icon="layer-image" size={16} />;

    case "video":
      return <SkiliticsIcon key="video-icon" icon="layer-video" size={16} />;

    case "model":
      return <SkiliticsIcon key="model-icon" icon="layer-3d" size={16} />;

    case "webObject":
      return <SkiliticsIcon key="web-object-icon" icon="layer-webobject" size={16} />;

    case "user.input":
      return <SkiliticsIcon key="user-input-icon" icon="layer-text-input" size={16} />;

    case "selectedEvaluationPattern":
      return <SkiliticsIcon key="evaluation-pattern-icon" icon="select-element" size={16} />;

    case "selectableOption":
      return <SkiliticsIcon key="option-icon" icon="layer-options" size={16} />;

    default:
      return <SkiliticsIcon key="var-icon" icon="layer-variable" size={16} />;
  }
};

export const useMapTypeIdToText = () => {
  const formatMessage = useFormatMessage(formatStrings);

  return (typeId: string) => {
    switch (typeId) {
      case "audio":
        return formatMessage("audio");

      case "image":
        return formatMessage("image");

      case "video":
        return formatMessage("video");

      case "model":
        return formatMessage("model");

      case "webObject":
        return formatMessage("webObject");

      case "user.input":
        return formatMessage("userInput");

      case "selectedEvaluationPattern":
        return formatMessage("evaluationPattern");

      case "selectableOption":
        return formatMessage("selectableOption");

      default:
        return formatMessage("variable");
    }
  };
};

const formatStrings = {
  audio: {
    en: "audio",
  },
  image: {
    en: "image",
  },
  video: {
    en: "video",
  },
  model: {
    en: "3D model",
  },
  variable: {
    en: "variable",
  },
  webObject: {
    en: "web object",
  },
  userInput: {
    en: "user input",
  },
  evaluationPattern: {
    en: "evaluation pattern",
  },
  selectableOption: {
    en: "option",
  },
} satisfies FormatMessages;
